import styled from 'styled-components';

export const StyledIconButton = styled.div`
  background: transparent;
  height: calc(${({ theme}) => theme.selectableButtonSize} * ${({ theme, $rows }) => $rows});
  min-height: calc(${({ theme}) => theme.selectableButtonSize} * ${({ theme, $rows }) => $rows});
  width: 100%;
  cursor: pointer;
  padding: 2px;
  position: relative;
  cursor: ${({ $disabled }) => $disabled ? undefined : 'pointer'};
  opacity: ${({ $disabled }) => $disabled ? '0.4' : '1.0'};

  &.icon-button-wrapper-responsive {
    @media (max-height: 640px) {
      height: 40px;
      min-height: 40px
    }
  }

  &:hover {
    .icon-button-corner {
      opacity: ${({ $disabled }) => $disabled ? '0.0' : '1.0'};
    }

    .icon-button-corner-l {
      border-right: none;
    }

    .icon-button-corner-r {
      border-left: none;
    }
  }

  .icon-button-corner {
    transition: opacity linear 0.2s;
    border: solid ${({ theme }) => theme.buttonFrameWidth} ${({ theme, $selected }) => $selected ? theme.selection : 'white'};
    opacity: ${({ $selected }) => $selected ? '1.0' : '0.0'};
    position: absolute;
    top: 0;
    bottom: 0;
    width: 8px
  }

  .icon-button-corner-l {
    border-right: none;
    left: 0;
  }

  .icon-button-corner-r {
    border-left: none;
    right: 0;
  }

  .icon-button {
    border: solid 2px ${({ $borderOverwrite }) => $borderOverwrite ? $borderOverwrite : 'rgba(0, 0, 0, .16)'};
    color: black;
    background: ${({ theme, $backgroundOverwrite }) => $backgroundOverwrite ? $backgroundOverwrite : theme.baseYellow};
    cursor: ${({ $disabled }) => $disabled ? undefined : 'pointer'};
    width: 100%;
    text-transform: uppercase;
    font-family: "BebasNeue";
    font-size: 2em;
    font-weight: 700;
    padding: 3px 8px;
    height: 100%;
    min-height: 100%;
    width: 100%;
    min-width: 100%;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    line-height: 1.4;
    transition: padding linear 0.2s;

    @media (max-width: ${({ theme }) => theme.mobile}) {
      border-width: 1px;
      font-weight: 700;
    }

    &:hover {
      border-color: ${({ theme, $borderOverwrite, $borderOverwriteHover, $disabled }) => $disabled ? ($borderOverwrite ? $borderOverwrite : theme.borderYellow) : ($borderOverwriteHover ? $borderOverwriteHover : ($borderOverwrite ? $borderOverwrite : theme.borderYellow))};
      background: ${({ theme, $backgroundOverwrite, $backgroundOverwriteHover, $disabled }) => $disabled ? ($backgroundOverwrite ? $backgroundOverwrite : theme.baseYellow) : ($backgroundOverwriteHover ? $backgroundOverwriteHover : ($backgroundOverwrite ? $backgroundOverwrite : theme.brightYellow))};
      padding: 3px ${({ $animated }) => $animated ? '15px' : '8px'};
    }
  }

  .icon-button.icon-button-responsive {
    @media (max-height: 640px) {
      padding: 0 8px;
      font-size: 1.7rem;
      &:hover {
        padding: 0 ${({ $animated }) => $animated ? '15px' : '8px'};
      }
    }
  }
`;
